/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPatient = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7zm-.498 10.52C5.48 18.385 5 19.585 5 21v1H3v-1c0-1.9.664-3.7 2.212-5.008C6.739 14.703 9 14 12 14c3 0 5.261.704 6.788 1.992C20.336 17.3 21 19.1 21 21v1h-9.667C9.937 22 9 20.767 9 19.5s.937-2.5 2.333-2.5h1.946l.307-.919A14.73 14.73 0 0 0 12 16c-2.715 0-4.453.638-5.498 1.52zm9.056-1.033L14.389 20h4.525c-.18-.984-.643-1.827-1.415-2.48-.487-.41-1.124-.768-1.94-1.033zM12.28 20l.334-1h-1.28c-.05 0-.122.021-.195.104-.075.084-.138.221-.138.396s.063.312.138.396c.073.083.144.104.195.104z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPatient as Patient };
